import { Component } from "@angular/core";
import { FieldType } from "@ngx-formly/core";

@Component({
  selector: "app-formly-field-custom-label",
  templateUrl: "./custom-label.component.html",
  styleUrls: ["./custom-label.component.scss"],
})
export class CustomLabelComponent extends FieldType {}
